import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SettingsSectionWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: ${Spacing.S32};
  padding: ${Spacing.S32} ${Spacing.S40};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.White};

  &:last-child {
    margin-bottom: 0;
  }
`
